import { CheckoutContext } from '@/context/CheckoutContext';
import { useContext } from 'react';
import { SavedCardsForm } from './SavedCardsForm';
import { InitialCreditCardForm } from './InitialCreditCardForm';
import { Disclaimer } from '../Common/Disclaimer';
import { useTranslate } from '@/hooks/useTranslate';

export const CreditCardForm = () => {
  const {
    card: { savedCards },
  } = useContext(CheckoutContext);
  const { t } = useTranslate();

  return (
    <div data-testid="credit-card-form" className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <div className="text-base text-card-foreground font-bold">{t('payWithDebitOrCreditCard')}</div>
        <Disclaimer />
      </div>
      {savedCards.length ? <SavedCardsForm /> : <InitialCreditCardForm />}
    </div>
  );
};
